
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, ButtonGroup } from "@mosanic/fields";
import { doubleArrowUpIcon, dragHandleIcon, moveHandleIcon } from "@mosanic/Icons/ScreenIcons";
import { updateDragDropState, updatePref } from "@redux/options/action";
import { canDragDropSelector, canMoveCanvasSelector, canZoomPinchSelector } from "@redux/options/reducer";
import styled from "styled-components";
import { useWindowSize } from '@hooks/useWindowSize';

const Controls = styled.div` 
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 99;
  width: 200px;
  height: 45px;
  background: rgba(255,255,255,0.8);
  backdrop-filter: blur(3px);
  display: none;

  @media (max-width: 600px) {
    display: block;
  }
`
const CanvasControls = ({}) => {
    const {width} = useWindowSize()
    const moveCanvas = useSelector(canMoveCanvasSelector)
    const dragDrop = useSelector(canDragDropSelector)
    const props = {moveCanvas, dragDrop, width};

    return (width < 600 || !dragDrop || !moveCanvas) ? <ControlsItem {...props} /> : null
}
const ControlsItem = ({width, dragDrop, moveCanvas}) => {
  const dispatch = useDispatch();
  
  const [active, setActive] = useState('Canvas');

  const options = [{
    icon: moveHandleIcon,
    value: 'Canvas'
  },{
    icon: dragHandleIcon,
    value: 'Drag'
  },{
    icon: doubleArrowUpIcon,
    value: 'Click'
  }]
  const setDragDrop = useCallback((state) => dispatch(updateDragDropState(state)),[dispatch])
    const setMoveCanvas = useCallback((state) => dispatch(updatePref({group: 'builder', pref: 'moveCanvas'}, state)),[dispatch])
  
  useEffect(() => {
    if(width < 600){
        if(moveCanvas && active != 'Canvas') setMoveCanvas(false);
        if(!moveCanvas && active === 'Canvas') setMoveCanvas(true);
        if(dragDrop && active != 'Drag') setDragDrop(false);
        if(!dragDrop && active === 'Drag') setDragDrop(true);
    } else {
    }
  },[active, dragDrop, dispatch, width, setMoveCanvas, setDragDrop, moveCanvas])

  useEffect(() => {
    if(width > 600){
        if(!moveCanvas) setMoveCanvas(true);
        if(!dragDrop) setDragDrop(true);
    }
  },[dragDrop, moveCanvas, setDragDrop, setMoveCanvas, width])
  if(width > 600) return null;
  return (
        <Controls>
          <ButtonGroup height="45px">
            {options.map(option => (
              <Button 
                active={option.value === active}
                onClick={() => setActive(option.value)}
                icon={option.icon} 
                label={option.value} 
                double size="large" 
                key={option.value} 
              />
            ))}
          </ButtonGroup>
        </Controls>     

  );
};


export default CanvasControls;
